document.addEventListener('DOMContentLoaded', function() {
  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
    });
  });
  // Mobile nav toggle
  var burger = document.querySelector('.site-nav__burger');
  var nav = document.querySelector('.site-nav');
  if (burger && nav) {
    burger.addEventListener('click', function() {
      nav.style.display = nav.style.display === 'flex' ? 'none' : 'flex';
      nav.style.flexDirection = 'column';
      nav.style.position = 'absolute';
      nav.style.top = '100%';
      nav.style.left = '0';
      nav.style.right = '0';
      nav.style.background = '#fff';
      nav.style.borderBottom = '1px solid #e8e6e1';
      nav.style.padding = '1rem 1.5rem';
      nav.style.zIndex = '200';
    });
  }
  // Shows: hide Bandsintown's RSVP and Notify Me buttons (keep Tickets)
  var shows = document.querySelector('#shows .shows__list');
  if (shows) {
    var hideButtons = function() {
      shows.querySelectorAll('a, button').forEach(function(el) {
        var t = (el.textContent || '').trim().toLowerCase();
        if (t === 'rsvp' || t.indexOf('notify me') === 0) { el.style.display = 'none'; }
      });
    };
    hideButtons();
    new MutationObserver(hideButtons).observe(shows, { childList: true, subtree: true });
  }
});
